function UpdRelocationPlanDependant() {
    return {
        // ConcurrencyCheck: [],
        AreDependentsCurrentLocation: false,
        CaseID: 0,
        CategorisationLocationName: null,
        CategorisationRecognisedDate: null,
        ContactNumber: null,
        CurrentState: 0,
        DefenceCategorisationID: 0,
        DependentStreetAddress: null,
        DependantsCount: null,
        DependentOtherAddressID: null,
        EmailID: null,
        IsTravellingWithDependents: false,
        IsTravellingWithPartner: false,
        NumberOfAdults: null,
        NumberOfChildren: null,
        OfficerName: null,
        OrderSubTypeID: 0,
        RelocationDependents: [],
        RelocationPlanID: 0,
    }
}

function UpdRelocationDependents() {
    return {
        RelocationPlanDependentID: 0,
        RelocationPlanID: 0,
        FamilyMemberPartyID: 0,
        RankLosingLocationID: null,
        RankLosingLocationDesc: null,
        RankGainingLocationID: null,
        RankGainingLocationDesc: null,
        GainingSchoolTypeID: null,
        RelationshipOther: null,
        ConcurrencyCheck: null,
        OrderSubTypeID: 0,
        Dependant: UpdDependantData,
        CurrentState: 0
    }
}

function UpdDependantData() {
    return {
        IsClientTypeAsDefence: false,
        IsDeleted: false,
        PartyID: 0,
        GivenName: null,
        MiddleName: null,
        FamilyName: null,
        TitleID: 0,
        TitleDesc: null,
        PreferredName: null,
        DateOfBirth: null,

        PartyStatusID: 0,
        GenderTypeID: 0,
        GenderTypeDesc: null,
        PartyRelatedRoleID: 0,
        PartyRelatedRoleDesc: null,
        PartyRelatedPartyID: 0,
        ADFRecognised: false,
        ADFRecognisedDate: null,
        ADFRecognisedLocation: null,
        IsEmployeeNumberReminder: false,
        RelationshipOther: null,
        ConcurrencyCheck: null,
        PartyConcurrencyCheck: null,
        PartyRelatedConcurrencyCheck: null,
        FamilyMemberConcurrencyCheck: null,
        ADFAPSEmployee: false,
        DepartmentID: 0,
        ClientOrganisationPartyDesc: null,
        ClientOrganisationPartyID: 0,
        EmployeeNumber: null,
        ServiceNumber: null,
        ADFReserve: false,
        ForeignDefenceExchangePersonnel: false,

        PartySubTypeID: 0,
        IndividualSubTypeID: 0,
        GainingSchoolTypeID: 0,
        CurrentState: 0

    }
}

function OrderStreetAddressDetail() {
    return {
        AddressID: 0,
        StreetAddressAddressID: 0,
        AddressSubTypeID: 0,
        ConcurrencyCheck: [],
        StreetAddressLine1: "",
        StreetAddressLine2: "",
        StreetAddressLine3: null,
        StreetAddressConcurrencyCheck: [],
        IsPrimaryContact: false,
        StreetAddressPostCode: "",
        StreetAddressCity: "",
        StreetAddressState: "",
        StreetAddressCountry: "Australia",
        StreetAddressLatitude: 0,
        StreetAddressLongitude: 0,
        IsValidated: true,
        StreetAddressSubTypeID: 0,
        CurrentState: 0
    }
}

export {
    UpdRelocationPlanDependant,
    UpdRelocationDependents,
    UpdDependantData ,
    OrderStreetAddressDetail
};
